<template>
	<div>
		<v-button
			type="button"
			class="mb-sm inline-block bg-red-500 text-white"
			:aria-label="buttonText"
			@click="openTypeForm"
		>
			{{ buttonText }}
		</v-button>
	</div>
</template>

<script setup lang="ts">
import * as typeform from "@typeform/embed";
import "@typeform/embed/build/css/slider.css";

const properties = defineProps<{
	formId: string;
	buttonText: string;
}>();

const openTypeForm = () => {
	const {createSlider} = typeform;
	const {open} = createSlider(properties.formId);

	open();
};
</script>
